<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Denuncias de jugadas"   />

    <PlayerComplaints />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue";
import PlayerComplaints from "@/components/Pages/Admin/PlayerComplaints/index.vue";

export default defineComponent({
  name: "PlayerComplaintsPage",
  components: {
    PageTitle,
    PlayerComplaints,
  },
});
</script>
